<template>
     <div class="wrapper">
        <div class="center-wrapper footer-bar">
          <div class="top">
              <div class="smlogo">
                <img src="../assets/img/footer-logo.png" alt="">
              </div>
             <div class="tel-wrap">
                  <span><img src="../assets/img/tel.png" alt=""><span>全国服务热线</span></span>
                  <p>400-900-5991</p>
                  <div>Mon&nbsp;To&nbsp;Sun&nbsp;<i class="triangle"></i>&nbsp;9:00-17:00</div>
             </div>
             <div class="navbar" @click="routerPush">
                  <div class="table-row">
                    <div class="table-cell" :data-path='item.goPath || item.path' :class="item.path === $route.path ? 'cell-active' : ''" v-for="(item, index) of navList.topNav" :key="index">{{item.title}}</div>
                  </div>
                  <div class="table-row">
                    <div class="table-cell" :data-path='item.goPath || item.path' :class="item.path === $route.path ? 'cell-active' : ''" v-for="(item, index) of navList.bottomNav" :key="index">{{item.title}}</div>
                  </div>
             </div>
             <div class="other">
                  <div class="img-box">
                     <img src="../assets/img/gzh.png" alt="">
                     <img src="../assets/img/wxIcon.png" alt="">
                  </div>
                   <div class="img-box">
                     <img src="../assets/img/mpQrCode.png" alt="">
                     <img src="../assets/img/mpIcon.png" alt="">
                  </div>
                   <div class="img-box">
                     <img src="../assets/img/xhs.png" alt="">
                     <img src="../assets/img/xhsIcon.png" alt="">
                  </div>
                   <div class="img-box">
                     <img src="../assets/img/douyin.png" alt="">
                     <img src="../assets/img/dyIcon.png" alt="">
                  </div>    
             </div>
          </div>
          <div class="below" @click="goGov">
                <p>广州智立方信息科技有限公司</p>
                <p>COPYRIGHT ©</p>
                <p>ICP备案号:粤ICP备17044065号-2</p>
          </div>
        </div>
     </div>
</template>
<script>
  export default {
  name: 'Footer',
  props: {
    active:{
        type:String,
        default:'0'
    }
  },
  data(){
    return {
        navList : {
          topNav: [
              {
                title: '证书查询',
                path: '/'
              },{
                title: '业内专家',
                path: '/Expert'
              },{
                title: '珠宝百科',
                path: '/jewelryEncyc',
                goPath: '/jewelryEncyc?jewelryEncycType=0'
              }
          ],
          bottomNav: [
            {
              title: '实用工具',
              path: '/utilities',
                goPath: '/utilities?utilType=1'
            },{
              title: '行业讯息',
              path: '/Trade'
            },{
              title: '关于我们',
              path: '/aboutUs'
            }
          ]
      }
    }
  },
  watch: {
    '$store.state.jewelryEncycData' (value) {
      this.navList.topNav[2].goPath = `/jewelryEncyc?jewelryEncycType=${value.data.left_list[0].id}`
      this.$forceUpdate()
    }
  },
  created(){},
  mounted(){},
  methods:{
    goGov(){
      window.open('https://beian.miit.gov.cn/')
    },
    routerPush (e) {
      if (e.target.className.indexOf('table-cell') !== -1) {
        this.$router.push(e.target.getAttribute('data-path'))
        window.scrollTo(0,0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  margin:auto;
  margin-top: 30px;
  background:#2093CA;
    .footer-bar {
       height: 300px;
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;
       color: #ffffff;
       .top {
          width: 100%;
          height: 90%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0 50px 0;
          .smlogo {
            //  width: 130px;
            //  height: 130px; 
            object-fit: cover;
          }
          .tel-wrap {
            height: 103px;
            min-width: 225px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            img {
              width: 21px;
              height: 21px;
              object-fit: cover;
              margin-right: 10px;
            }
            span {
                font-size: 18px;
                font-weight: 500;
            }
            p {
              font-size: 32px;
              font-weight: 700;
            }
            .triangle {
              display: inline-block;
              width: 0;
              height: 0;
              border-left: 6px solid #ffffff;
              border-top: 6px solid transparent;
              border-right: 6px solid transparent;
              border-bottom: 6px solid transparent;
            }
            div {
              font-size: 18px;
              font-weight: 400;
              text-align: center;
              line-height: 18px;
             
            }
          }
       }
       .navbar {
            height: 103px;
            display: table;
            font-size: 18px;
            font-weight: 500;
            .table-row { 
              display: table-row;
              &:last-child {
                 .table-cell {
                    border-bottom: none;
                 }
              }
              .cell-active {
                 background: rgba(255, 255, 255, 0.12);
              }
            }
            .table-cell {
              cursor: pointer;
              display: table-cell;
              vertical-align: middle;
              text-align: center;
              width: 117px;
              height: 55px;
              border-right: 1px solid rgba(255, 255, 255, 1);
              border-bottom: 1px solid rgba(255, 255, 255, 1);
              transition: all 0.3s;
              background: rgba(32,147,202,1);
              &:last-child {
                 border-right: none;
              }
              &:hover {
                background: rgba(255, 255, 255, 0.12);
              }
            }
        }
        .other {
          height: 103px;
          width: 400px;
          display: flex;
          justify-content: space-between;
          align-items: center;
            .img-box {
             display: flex;
             flex-direction:column;
             justify-content: space-around;
             align-items: center;
             img:first-child{
               margin-bottom: 6px;
             }
          }
        }
       .below {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          padding-bottom: 14px;
          p{
            margin-right: 20px;
          }
       }
    }
}
</style>